import { render, staticRenderFns } from "./Mangelinstrumente.vue?vue&type=template&id=76c0fbbe&"
import script from "./Mangelinstrumente.vue?vue&type=script&lang=js&"
export * from "./Mangelinstrumente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports